import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface UserState {
    id: string;
    name: string;
    email: string;
    phoneNr: string;
    password: string;
    isAuth: boolean;
    cartCount: number;
    qrCodeCount: number;
    address: string;
}

const initialState: UserState = {
    id: '',
    name: '',
    email: '',
    phoneNr: '',
    password: '',
    isAuth: false,
    cartCount: 0,
    qrCodeCount: 0,
    address: '',
}

const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        setUserValue: <T extends keyof UserState>(state: UserState, action: PayloadAction<{ key: T, value: UserState[T] }>) => {
            const { key, value } = action.payload;
            state[key] = value;
        },
        logoutUser(state) {
            state.id = '';
            state.name = '';
            state.email = '';
            state.phoneNr = '';
            state.password = '';
            state.isAuth = false;
            state.cartCount = 0;
            state.qrCodeCount = 0;
            state.address = '';
        },
    }
});

export const { setUserValue, logoutUser } = userSlice.actions;

export default userSlice.reducer;